import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { CreateShopStepLocations } from '../StepLocations';
import { CreateShopStepGeneral } from '../StepGeneral';
import { CreateShopStepApplicationSuccessfull } from '../StepApplicationSuccessfull';
import { ICreateShopObject } from 'models/shop/createshop';
import {
	submitCreateShop,
	clearFormData,
	nextStep,
	previousStep,
	setStep,
	setCustomShipping,
	createShopCropImage,
} from 'modules/shop/createshop';
import { IStore } from 'redux/IStore';
import { RouteComponentProps } from 'react-router';
import { destroy } from 'redux-form';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { LoadingOverlayWrapper } from '../../../../components/Loader';
import { WizardSideNav } from 'components/WizzardSideNav';
import { CreateShopStepMembers } from '../StepMembers';
import Helmet from 'react-helmet';
import { Dispatch } from 'redux';
import { ICropImageData, ITranslateProps } from 'models/common';
import { sendVerificationEmail } from 'redux/modules/user/userpreferences';
import { Button } from 'components';
const folderImage = require('containers/Html/images/email-folder-open.svg');
const { connect } = require('react-redux');

interface IOwnProps extends RouteComponentProps<{}, {}> {}

interface IProps
	extends IOwnProps,
		ReturnType<typeof stateToProps>,
		ReturnType<typeof dispatchToProps>,
		ITranslateProps {}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CreateShopComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.state = {
			hasResentVerificationEmail: false,
		};

		this.sendVerificationEmail = this.sendVerificationEmail.bind(this);
	}

	public componentWillUnmount() {
		this.props.clearFormData();
		this.props.destroyForm();
	}

	private onSubmit(form?: ICreateShopObject) {
		if (form) {
			this.props.submitCreateShop(form);
		}
	}

	private sendVerificationEmail(e: React.SyntheticEvent) {
		e.preventDefault();
		this.props.sendVerificationEmail();
		this.setState({ hasResentVerificationEmail: true });
	}

	public render() {
		const { t, userPreferences } = this.props;
		const { wizardStep } = this.props.createShop;

		const titles = [
			t('Shop_ManageShop_General_Label_SalonInfo'),
			t('Shop_ManageShop_Location_Label_Locations'),
			t('Shop_ManageShop_Members_Title'),
			// t('Shop_ManageShop_Payment_Title'),
		];

		// const finalStep = 3;
		const finalStep = 2;
		const wizardProps = (step: number) => ({
			route: this.props.route,
			router: this.props.router,
			previousPage: this.props.previousStep,
			onSubmit: step === finalStep ? this.onSubmit : this.props.nextStep,
			// userPreferences,
		});

		if (!userPreferences.emailVerified) {
			return (
				<div className="createShop unverified-email container topPadding">
					<div className="row justify-content-center">
						<main className="verify-email-notice col-12 col-lg-10 col-xl-9 ">
							<img src={folderImage} alt="confirm email icon" />
							<div>
								<h1 className="verify-email-title">
									{t('Shop_CreateShop_VerifyEmail_Title_1')} <b>{t('Shop_CreateShop_VerifyEmail_Title_2')}</b>
								</h1>
								<p>{t('Shop_CreateShop_VerifyEmail_Info_1')}</p>
								<p>{t('Shop_CreateShop_VerifyEmail_Info_2')}</p>
								{!this.state.hasResentVerificationEmail ? (
									<Button onClick={this.sendVerificationEmail}>
										{t('User_UserPreferences_Resend_Verification_Email')}
									</Button>
								) : null}
							</div>
						</main>
					</div>
				</div>
			);
		}

		return (
			<LoadingOverlayWrapper
				className="boxedLayout container-fluid topPadding"
				active={userPreferences.isUserShopsFetching}
				spinner={true}
				text={t('BSPortal_Common_Loading')}
				background="rgba(0, 0, 0, 0.1)"
			>
				<aside>
					<WizardSideNav
						goTo={this.props.gotoStep}
						steps={titles}
						active={wizardStep}
						lastEnabledStep={wizardStep}
						customClass={'shopCreateSidemenu'}
					/>
				</aside>
				<main className="createShop">
					<h5 className="text-center">{wizardStep + 1}/3</h5>
					{wizardStep === 0 && (
						<CreateShopStepGeneral {...wizardProps(0)} createShopCropImage={this.props.createShopCropImage} />
					)}
					{wizardStep === 1 && <CreateShopStepLocations {...wizardProps(1)} />}
					{wizardStep === 2 && (
						<CreateShopStepMembers {...wizardProps(2)} customMemberClassName="staffMembers__desktopMemberCreateShop" />
					)}
					{/* {wizardStep === 3 && <CreateShopStepPayment {...wizardProps(3)} />} */}
					{wizardStep === 4 && (
						<CreateShopStepApplicationSuccessfull shopCode={this.props.createShop.createShopObj?.shop?.code} />
					)}
				</main>
				<Helmet title={t('Shop_CreateShop_Label_CreateStore')} />
			</LoadingOverlayWrapper>
		);
	}
}

const stateToProps = (state: IStore) => ({
	createShop: state.createShop,
	userPreferences: state.userPreferences,
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	submitCreateShop: (createShopObj: ICreateShopObject) => dispatch(submitCreateShop(createShopObj)),
	clearFormData: () => dispatch(clearFormData()),
	gotoStep: (step: number) => dispatch(setStep(step)),
	firstStep: () => dispatch(setStep(1)),
	nextStep: () => dispatch(nextStep()),
	previousStep: () => dispatch(previousStep()),
	getShopCard: (id: string) => dispatch(getShopCard(id)),
	setCustomShipping: (customShipping: boolean) => dispatch(setCustomShipping(customShipping)),
	destroyForm: () => dispatch(destroy(c.FORM_NAME_CREATE_SHOP)),
	createShopCropImage: (image: ICropImageData) =>
		dispatch(
			createShopCropImage({
				...image,
				// thumbnails: c.DEFAULT_CROP_SIZES_PROFILE_IMAGE, // uncomment to create thumbnails right after crop on this step
			}),
		),
	sendVerificationEmail: () => dispatch(sendVerificationEmail()),
});

const CreateShop = connect(stateToProps, dispatchToProps)(CreateShopComponent);

export { CreateShop };
